<template>
    <div id="childReturn" class="page-content">
        <!-- 退货 -->
        <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
            <div v-for="(item, index) in returnList" @click="dinji(index)">
                <div style="display: flex;height: 50px;line-height: 50px;">
                    <el-input v-model="item.ordernumber" clearable disabled style="width: 178px;margin-right: 10px;"
                        size="small" v-if="type == 1" />

                    <div style="line-height: 56px;padding-right: 5px;color: #F56C6C;" v-if="type == 2">
                        *
                    </div>
                    <el-select v-model="item.ordernumber" placeholder="请选择订单编号" v-if="type == 2" size="small"
                        style="margin-right: 10px;width: 150px;" @change="selectChange(index, item.ordernumber)">
                        <el-option v-for="item in options" :key="item.ordernumber" :label="item.ordernumber"
                            :value="item.ordernumber">
                        </el-option>
                    </el-select>

                    <div style="line-height: 56px;padding-right: 5px;color: #F56C6C;">
                        *
                    </div>
                    <el-input v-model="item.returnNumber" clearable placeholder="退货数量"
                        style="width: 120px;margin-right: 10px;" type="number" size="small" />
                    <div style="line-height: 56px;padding-right: 5px;color: #F56C6C;">
                        *
                    </div>
                    <el-input v-model="item.refundPrice" clearable placeholder="退款金额"
                        style="width: 120px;margin-right: 10px;" type="number" size="small" />
                    <div style="line-height: 56px;padding-right: 5px;color: #F56C6C;">
                        *
                    </div>
                    <el-date-picker v-model="item.refundDate" value-format="yyyy-MM-dd" type="date"
                        placeholder="请选择退款到账日期" style="width: 190px;margin-right: 10px;" size="small"></el-date-picker>
                    <div style="line-height: 56px;padding-right: 5px;color: #F56C6C;">
                        *
                    </div>
                    <el-upload class="avatar-uploader" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                        style="width: 50px;height: 50px;" :show-file-list="false" :before-upload="handleBeforeUpload"
                        :on-success="handleUploadSuccess" accept="image/png, image/jpg" :ref="elUpload">
                        <img v-if="item.refundPriceScreenshot" :src="item.refundPriceScreenshot" class="avatar"
                            style="width: 50px;height: 50px;">
                        <i v-else class="el-icon-plus avatar-uploader-icon" style="width: 50px;height: 50px;"></i>
                    </el-upload>
                    <el-tooltip class="item" effect="dark" content="请上传退款到账截图" placement="top">
                        <i class="el-icon-warning" style="line-height: 50px;padding-left: 10px;"></i>
                    </el-tooltip>
                    <i class="el-icon-remove" style="line-height: 50px;padding-left: 10px;color: red;cursor: pointer;"
                        v-if="returnList.length != 0 && type == '2'" @click="del(index)"></i>
                </div>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" style="margin-left: 10px;margin-top: 10px;"
                @click="newAdd" v-if="type == 2">新增</el-button>
            <el-form ref="form" :model="form" :rules="rules" label-width="150px"
                style="height: 500px;overflow: auto;margin-top: 20px;" v-if="buytype != 'R买'">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="退货收件人" prop="returnRecipient">
                            <el-input v-model="form.returnRecipient" clearable placeholder="退货收件人" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="退货人收件人手机号" prop="returnRecipientPhone">
                            <el-input v-model="form.returnRecipientPhone" clearable placeholder="退货人收件人手机号"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="退货收件人地址" prop="returnAddress">
                            <el-input v-model="form.returnAddress" clearable placeholder="退货收件人地址" style="width: 410px;"
                                size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="退货运费支付日期" prop="returnPaymentDate">
                            <el-date-picker v-model="form.returnPaymentDate" value-format="yyyy-MM-dd" type="date"
                                placeholder="请选择" style="width: 410px;" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="退货快递单号" prop="returnTrackingNumber">
                            <el-input v-model="form.returnTrackingNumber" clearable placeholder="退货快递单号"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="退货运费支付截图" prop="returnPaymentScreenshot">
                            <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                                :show-file-list="false" :before-upload="handleBeforeUpload"
                                :on-success="handleUploadSuccess2" accept="image/png, image/jpg" :multiple="true"
                                :ref="elUpload">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <div v-for="(image, index) in returnPaymentScreenshot" :key="index"
                                style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                                <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                                <i class="el-icon-error"
                                    style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                    @click="delIcon(index)"></i>
                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="退货运费金额" prop="returnPaymentPrice">
                            <el-input v-model="form.returnPaymentPrice" clearable placeholder="退货运费金额"
                                style="width: 410px;" size="small" type="number" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="title == '退货详情'">
                        <el-form-item label="创建时间">
                            {{ form.createtime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '退货详情'">
                        <el-form-item label="创建人">
                            {{ form.createuser }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '退货详情'">
                        <el-form-item label="更新时间" v-if="form.updatetime">
                            {{ form.updatetime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '退货详情'">
                        <el-form-item label="更新人" v-if="form.updateuser">
                            {{ form.updateuser }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel(2)">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Select } from 'element-ui';

export default {
    name: "childReturn",
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            elUpload: true,
            elUpload2: true,
            title: '',
            form: {},
            rules: {
                returnRecipient: [
                    { required: true, message: '请填写退货收件人', trigger: 'blur' },
                ],
                returnRecipientPhone: [
                    { required: true, message: '退货人收件人手机号', trigger: 'blur' },
                ],
                payuserphone: [
                    { required: true, message: '请填写购买账号', trigger: 'blur' },
                ],
                returnPaymentDate: [
                    { required: true, message: '请选择退货运费支付日期', trigger: 'blur' },
                ],
                returnAddress: [
                    { required: true, message: '请填写退货收件人地址', trigger: 'blur' },
                ],
                returnTrackingNumber: [
                    { required: true, message: '请填写退货快递单号', trigger: 'blur' },
                ],
                returnPaymentScreenshot: [
                    { required: true, message: '请选择退货运费支付截图', trigger: 'blur' },
                ],
                returnPaymentPrice: [
                    { required: true, message: '请填写退货运费金额', trigger: 'blur' },
                ],
                freightinsurance: [
                    { required: true, message: '请填写购买账号', trigger: 'blur' },
                ],
            },
            rules2: {},
            open: false,
            returnList: [],
            dynamicRules: this.rules,
            buytype: '',
            options: [],
            dianjiIndex: 0,
            buytypeArr: [],
            returnPaymentScreenshot: [],
        };
    },
    created() {

    },
    methods: {
        delIcon(index) {
            this.returnPaymentScreenshot.splice(index, 1)
        },
        selectChange(index, ordernumber) {
            const orderNumberCounts = {};
            let hasDuplicates = false;

            this.returnList.forEach(item => {
                if (orderNumberCounts[item.ordernumber]) {
                    orderNumberCounts[item.ordernumber]++;
                    if (orderNumberCounts[item.ordernumber] > 1) {
                        hasDuplicates = true;
                    }
                } else {
                    orderNumberCounts[item.ordernumber] = 1;
                }
            });

            if (hasDuplicates) {
                this.$message.error('该订单已存在退货');
                this.returnList[index].ordernumber = null
                return
            } else {
                console.log('没有重复的订单号');
            }

            for (let a in this.options) {
                if (this.options[a].ordernumber == ordernumber) {
                    this.returnList[index].orderid = this.options[a].id;
                    this.returnList[index].ordertaskid = this.options[a].taskid;
                }
            }
        },
        updateChange(data) {
            this.form = {};
            this.title = data.title;
            console.log(data)
            if (data.form.returnsublistlist) {
                this.returnList = []
                this.buytypeArr = []
                this.returnList = data.form.returnsublistlist;
                this.buytype = data.form.returnsublistlist[0].buytype;
                for (let a in this.returnList) {
                    if (this.returnList[a].refundDate) {
                        this.returnList[a].refundDate = this.$options.filters.fullTime(this.returnList[a].refundDate)
                    }
                    this.buytypeArr.push(this.returnList[a].buytype)
                }
            }
            if (this.type == '2') {
                if (data.form.details) {
                    this.form = data.form.details;
                    this.buytype = this.form.buytype;
                    this.form.returnPaymentDate = this.$options.filters.fullTime(this.form.returnPaymentDate);
                    this.returnPaymentScreenshot = data.form.details.returnPaymentScreenshot.split(',');
                }
                this.OrderChange();
            } else {
                this.open = true;
            }
            if (this.buytype == 'R买') {
                this.dynamicRules = this.rules2;
            } else {
                this.dynamicRules = this.rules;
            }

        },
        // 获取订单编号
        OrderChange() {
            let params = {}
            fetch({
                url: "hcm/hcmOrdergoods/getListOrderPaynumsurplus",
                method: "get",
                noFormat: true,
                params: params,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.options = []
                    if (this.type == '2') {
                        if (result.data.length > 0) {
                            if (this.buytype == 'R买') {
                                for (let a in result.data) {
                                    if (result.data[a].buytype == 'R买') {
                                        this.options.push(result.data[a])
                                    }
                                }
                            } else {
                                for (let a in result.data) {
                                    if (result.data[a].buytype !== 'R买') {
                                        this.options.push(result.data[a])
                                    }
                                }
                            }

                        }
                    } else {
                        this.options = result.data;
                    }
                    let ordernumberArr = []
                    ordernumberArr = this.form.ordernumber.split(',')

                    if (this.form && ordernumberArr.length > 0) {

                    } else {
                        this.returnList.push({
                            ordernumber: '',
                            returnNumber: '',
                            refundPrice: '',
                            refundDate: '',
                            refundPriceScreenshot: '',
                            orderid: '',
                            ordertaskid: '',
                        })
                    }
                    this.open = true;
                }
            })
        },
        newAdd() {
            this.returnList.push({
                ordernumber: '',
                returnNumber: '',
                refundPrice: '',
                refundDate: '',
                refundPriceScreenshot: '',
                orderid: '',
                ordertaskid: '',
            })
        },
        del(index) {
            this.returnList.splice(index, 1);
        },
        // 图片上传前判断
        handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
        handleUploadSuccess(res) {
            this.returnList[this.dianjiIndex].refundPriceScreenshot = res.data.data;
            this.elUpload = false;
        },
        handleUploadSuccess2(res) {
            this.returnPaymentScreenshot.push(res.data.data);
            this.elUpload2 = false;
        },
        dinji(index) {
            console.log(index)
            this.dianjiIndex = index;
        },
        // 提交
        submitForm() {
            let ordernumber = []
            for (var i in this.returnList) {
                const item = this.returnList[i];
                if (item.ordernumber === '' || !item.ordernumber) {
                    this.$message({
                        message: '请选择订单编号',
                        type: 'warning'
                    });
                    return
                }
                if (item.returnNumber === '') {
                    this.$message({
                        message: '请填写退货数量',
                        type: 'warning'
                    });
                    return
                }
                if (item.refundPrice === '') {
                    this.$message({
                        message: '请填写退款金额',
                        type: 'warning'
                    });
                    return
                }
                if (item.refundDate === '') {
                    this.$message({
                        message: '请选择退款到账日期',
                        type: 'warning'
                    });
                    return
                }
                if (item.refundPriceScreenshot === '') {
                    this.$message({
                        message: '请点击弹窗右上角+号录入退款到账截图',
                        type: 'warning'
                    });
                    return
                }
                ordernumber.push(item.ordernumber)
            }
            this.form.orderreturnsubList = this.returnList
            this.form.ordernumber = ordernumber.join(',')
            this.form.buytype = this.buytypeArr.join(',')
            this.form.returnPaymentScreenshot = this.returnPaymentScreenshot.join(',')
            fetch({
                url: "hcm/hcmOrderReturn/savaOrderReturn",
                method: "post",
                data: JSON.stringify(this.form),
                headers: {
                    'Content-Type': 'application/json',
                },
                noFormat: false,
                responseType: "json"
            }).then((res) => {
                if (res.status === '10000') {
                    this.$message({
                        message: '操作成功！',
                        type: 'success'
                    })
                    this.open = false;
                } else {
                    this.$message.error(res.message);
                }
                this.$emit('call-parent-method');
            }).catch(err => {
                this.$message.error('服务器出错');
            });
        },
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 50px;
    width: 50px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

#childReturn {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>